const selectors = {
  readMoreBtn: document.querySelector('[data-readMoreBtn]'),
  showMoreBtn: document.querySelector('[data-show-mores]'),
  readMoreContainer: document.querySelector('[data-readMoreContainer]')
};
class templateCollectionJS {
  constructor() {
    this.readMore();
    this.productCardHeight();

    if (selectors.showMoreBtn != null) {
      selectors.showMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelectorAll('[data-show-all]').forEach(function (target) {
          target.style.display = 'inline-flex';
        });
        e.currentTarget.style.display = 'none';
      });
    }

    this.showQTYdiscount();
  }

  showQTYdiscount() {
    document.querySelectorAll('[data-collection-lists]').forEach(function (target) {
      // get all tags
      const jsonProduct = target.querySelector('[data-productJSON]').innerHTML;
      const arrayProduct = JSON.parse(jsonProduct);
      const productTags = arrayProduct.tags;

      const bagValue = target.querySelector('[data-per-bag]').value;

      let sortPrice = [];
      let sortPriceArray = [];

      var headHTML = '',
        bodyHTML = '';

      productTags.forEach(function (value, key) {
        if (value.indexOf('pricing_') > -1) {
          sortPriceArray.push(parseInt(value.replace('pricing_', '').split('_')[0].split('-')[0].replaceAll('/', '').replaceAll('"', '').replace('+', '')))
        }
      });

      // Sort Array
      sortPrice = sortPriceArray.sort(function (a, b) { return a - b });

      sortPrice.forEach(function (val, keymain) {
        productTags.forEach(function (value, key) {
          if (value.indexOf('pricing_') > -1) {
            let valueNew = parseInt(value.replace('pricing_', '').split('_')[0].split('-')[0].replace('+', ''));
            if (valueNew == val) {
              if (keymain == 0) {
                target.querySelector('[data-show-price]').innerHTML = value.split('_')[2].replace('"', '');
              }
              if (sortPrice[sortPrice.length - 1] == val) {
                target.querySelector('[data-show-price-min]').innerHTML = value.split('_')[2].replace('"', '');
              }
              headHTML += `<th><span data-qty="${value.split('_')[1]}">${value.split('_')[1]}</span></th>`;
              bodyHTML += `<td><span data-price="${value.split('_')[1]}" ${keymain == 0 ? 'data-main-price' : ''}>${value.split('_')[2].replace('"', '')}</span></td>`;
            }
          }
        });
      });
      var HTMLcontent = `<table class="table mb-0 font-size-sm">
                             <thead class="group-name">
                                  <tr>
                                    ${headHTML}
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr>
                                    ${bodyHTML}
                                  </tr>
                              </tbody>
                          </table>`;
      
      target.querySelector('[data-discount-calculate]').innerHTML = HTMLcontent;
    });
  }

  readMore() {
    if (selectors.readMoreBtn) {
      selectors.readMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let currentTarget = e.target;
        let readMoreEle = selectors.readMoreContainer.querySelector('.hidden-text');
        if (readMoreEle) {
          if (selectors.readMoreContainer.classList.contains('open')) {
            Utility.toggleElement(selectors.readMoreContainer, 'close');
            currentTarget.innerHTML = 'Read More'
          } else {
            Utility.toggleElement(selectors.readMoreContainer, 'open');
            currentTarget.innerHTML = 'Read Less'
          }
        }
      });
    }
  }
  productCardHeight() {
    var maxHeight = 0;
    var maxHeightTitle = 0;
    var windowWidth = window.outerWidth;

    if (windowWidth >= 992) {
      document.querySelectorAll("[data-product-grid]").forEach(function (productCard) {

        if (maxHeight <= productCard.offsetHeight) {
          maxHeight = productCard.offsetHeight;
        }

      });

      document.querySelectorAll("[data-product-title-wrapper] .product-link").forEach(function (productCardTitle) {

        if (maxHeightTitle <= productCardTitle.offsetHeight) {
          maxHeightTitle = productCardTitle.offsetHeight;
        }

      });

      document.querySelectorAll("[data-product-grid]").forEach(function (productCard) {
        productCard.style.height = maxHeight + "px";
      });

      document.querySelectorAll("[data-product-title-wrapper] .product-link").forEach(function (productCardTitle) {
        productCardTitle.style.height = maxHeightTitle + "px";
      });
    }

  }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();


